/**
 * Getters for wordpress/posts module
 */
const getters = {
  all: state => state.posts,
  published: state => state.pages.filter(page => page.status === 'publish'),
  selected: state => state.selected
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/posts/getters.js